import { render } from "./StripeDirectDebitModal.vue?vue&type=template&id=1552f70f&scoped=true"
import script from "./StripeDirectDebitModal.vue?vue&type=script&lang=js"
export * from "./StripeDirectDebitModal.vue?vue&type=script&lang=js"

import "./StripeDirectDebitModal.vue?vue&type=style&index=0&id=1552f70f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1552f70f"

export default script